<template>
  <div v-loading='loading' class='all-menus'>
    <!-- 工具栏：「我的 / 全部」切换 + 搜索 + 当前模式说明 -->
    <div class='all-menus__toolbar'>
      <div class='all-menus__toolbar-left'>
        <el-radio-group v-model='menuMode' size='small' @input='handleChangeMode'>
          <el-radio-button v-for='(option,index) in menuModeOption' :label='option.value' :key='index'>
            {{ option.label }}
          </el-radio-button>
        </el-radio-group>
        <el-input
          v-model='searchKeyword'
          class='all-menus__search'
          size='small'
          clearable
          placeholder='搜索菜单名称'
          prefix-icon='el-icon-search'
        />
      </div>
      <span class='all-menus__hint'>
        {{ showAll ? '展示系统全部菜单，无权限的菜单会置灰不可点击' : '仅展示当前账号有权限的菜单' }}
        <b v-if='filteredMenuList.length'>（共 {{ filteredMenuList.length }} 个分组）</b>
      </span>
    </div>

    <!-- 菜单分组 -->
    <div v-for='(v ,k) in filteredMenuList' :key='k' class='nav'>
      <div class='boxTitle' v-if='showSubTitle'>
        <span class='boxTitle__name' :title='v.display_name'>{{ v.display_name }}</span>
        <span v-if='v.children && v.children.length' class='boxTitle__count'
              :title="`${v.children.length}个子菜单`">{{ v.children.length }}</span>
      </div>
      <div class='navBox'>
        <template v-if='(v.children && v.children.length)'>
          <div class='navBox__item' v-for='(item, indx) in v.children' :key='k + "-" + indx'>
            <el-link
              class='navItem'
              :class="v['permission_name'] &&!(userPermissions.indexOf(item['permission_name']) > -1)?'disabled':''"
              type='primary'
              :underline='false'
              @click='goToPage(item.url,item)'
              :disabled="v['permission_name'] &&!(userPermissions.indexOf(item['permission_name']) > -1)"
              v-if="(v['permission_name'] &&!(userPermissions.indexOf(item['permission_name']) === -1)) || showAll"
            >
              <svg-icon :style='{ color: setColor(indx) }' :icon-class="item['icon']"></svg-icon>
              <span :title="item['url']">{{ item['display_name'] }}</span>
            </el-link>
          </div>
        </template>
        <template v-else>
          <div class='navBox__item'
               v-if="(v['permission_name'] &&!(userPermissions.indexOf(v['permission_name']) === -1)) || showAll">
            <el-link type='primary' :underline='false' @click='goToPage(v.url,v)'
                     class='navItem'
                     :class="v['permission_name'] &&!(userPermissions.indexOf(v['permission_name']) > -1)?'disabled':''"
                     :disabled="v['permission_name'] &&!(userPermissions.indexOf(v['permission_name']) > -1)"
            >
              <svg-icon :style='{ color: setColor(k) }' :icon-class='v.icon'></svg-icon>
              <span :title='v.url'>{{ v.display_name }}</span>
            </el-link>
          </div>
        </template>
      </div>
    </div>

    <!-- 空态 -->
    <el-empty
      v-if='!loading && !filteredMenuList.length'
      :description='searchKeyword ? "未找到匹配的菜单" : "暂无可展示的菜单"'
      :image-size='80'
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import menuApi from '@/api/menu_setting'

export default {
  name: 'UserComponentsAllMenusNew',
  computed: {
    ...mapGetters(['userPermissions']),
    showAll() {
      return this.menuMode === 'all'
    },
    myMenuList() {
      if (!this.showAll)
        return this.getMenus()

      return this.navMenus
    },
    filteredMenuList() {
      const keyword = (this.searchKeyword || '').trim()
      if (!keyword)
        return this.myMenuList

      return this.filterByKeyword(this.myMenuList, keyword)
    }
  },
  props: {
    showSubTitle: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  watch: {
    userPermissions() {
      this.findPermissionsNav()
    }
  },
  data() {
    return {
      loading: false,
      navMenus: [],
      searchKeyword: '',
      colorArray: ['rgb(208, 48, 80)', 'rgb(31, 218, 202)', 'rgb(191, 12, 44)', '#7b84e6', 'rgb(63, 178, 127)', 'rgba(77, 175, 27, 0.79)', 'rgb(225, 133, 37)', 'rgb(0, 216, 255)'],
      allHasPermissions: [],
      menuModeOption: [
        { label: '全部', value: 'all' },
        { label: '我的', value: 'self' }
      ],
      menuMode: 'self'
    }
  },
  methods: {
    goToPage(routeName, menu) {
      if (menu.type === 'button') {
        this.$utils.jumpToButtonUrl(menu.url)
        return
      }
      this.$utils.jumpPage(this, routeName, menu)
    },
    setColor(k) {
      return this.colorArray[k % this.colorArray.length]
    },
    findPermissionsNav() {
      this.loading = true
      if (this.navMenus.length > 0 && this.userPermissions.length > 0) {
        this.allHasPermissions = this.navMenus
          .map((item) => {
            return this.userPermissions.indexOf(item['permission_name']) > -1 ? item : false
          })
          .filter(Boolean)
        this.loading = false
      }
    },
    handleChangeMode() {
      localStorage.setItem('profile:menu:mode', this.menuMode)
    },
    recursionMenu(menus, result = []) {
      for (const menu of menus) {
        const hasPerm = menu.permission_name && this.userPermissions.includes(menu.permission_name)
        const hasChildren = menu.children && menu.children.length > 0

        if (hasPerm) {
          result.push(menu)
        } else if (!menu.permission_name && hasChildren) {
          const filteredChildren = []
          this.recursionMenu(menu.children, filteredChildren)
          if (filteredChildren.length > 0) {
            result.push({ ...menu, children: filteredChildren })
          }
        }
      }
      return result
    },
    async fetchMenuTree() {
      this.loading = true
      try {
        const res = await menuApi.getMenuTree()
        const list = Array.isArray(res) ? res : Object.values(res || {})
        const activeList = this.filterActiveMenus(list)
        const sortedList = activeList.sort((a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0))
        this.navMenus = sortedList
      } catch (e) {
        console.error('获取菜单树失败', e)
      } finally {
        this.loading = false
      }
    },
    filterActiveMenus(menus) {
      return menus
        .filter(item => String(item.status) === '1')
        .map(item => {
          const filteredChildren = item.children ? this.filterActiveMenus(item.children) : []
          if (item.children && item.children.length > 0 && filteredChildren.length === 0) {
            return null
          }
          return { ...item, children: filteredChildren }
        })
        .filter(Boolean)
    },
    getMenus() {
      const menuArr = this.recursionMenu(this.navMenus)
      return menuArr
    },
    filterByKeyword(menus, keyword) {
      const kw = keyword.toLowerCase()
      return menus.reduce((acc, menu) => {
        const nameMatch = String(menu.display_name || '').toLowerCase().includes(kw)
        const children = menu.children && menu.children.length
          ? this.filterByKeyword(menu.children, keyword)
          : []

        if (nameMatch) {
          // 分组名命中，保留其全部有效子菜单
          acc.push({ ...menu, children: children.length ? children : menu.children })
        } else if (children.length) {
          // 子菜单命中的分组，仅保留命中的子菜单
          acc.push({ ...menu, children })
        }
        return acc
      }, [])
    }
  },
  mounted() {
    this.menuMode = localStorage.getItem('profile:menu:mode') || 'self'
    this.fetchMenuTree()
  }
}
</script>


<style lang='scss' scoped>
.all-menus {
  &__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px 12px;
    margin-bottom: 12px;
  }

  &__toolbar-left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  &__search {
    width: 220px;
  }

  &__hint {
    font-size: 12px;
    color: $--color-text-secondary;

    b {
      font-weight: 600;
      color: $--color-text-regular;
    }
  }
}

.nav {
  display: flex;
  align-items: stretch;
  margin-bottom: 12px;
  border: 1px solid $--border-Lighter-color;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  transition: border-color .2s ease, box-shadow .2s ease;

  &:hover {
    border-color: #ffd6e5;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .05);
  }

  &:last-child {
    margin-bottom: 0;
  }

  .boxTitle {
    flex: 0 0 132px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    box-sizing: border-box;
    padding: 10px 12px;
    background: #fafafa;
    border-right: 1px dashed $--border-Lighter-color;
    color: $--color-text-regular;
    font-size: 13px;
    font-weight: 600;

    &__name {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__count {
      flex-shrink: 0;
      min-width: 18px;
      height: 18px;
      padding: 0 5px;
      border-radius: 9px;
      background: #f0f2f5;
      color: $--color-text-secondary;
      font-size: 11px;
      font-weight: 400;
      line-height: 18px;
      text-align: center;
      box-sizing: border-box;
    }
  }
  .navBox {
    flex: 1;
    min-width: 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 6px 8px;
    align-content: flex-start;
    padding: 10px 12px;

    &__item {
      min-width: 0;
    }

    .navItem {
      display: flex;
      justify-content: flex-start;
      width: 100%;
      height: 34px;
      padding: 0 10px;
      border: 1px solid transparent;
      border-radius: 6px;
      background: #f7f8fa;
      color: $--color-text-primary;
      font-size: 13px;
      font-weight: 400;
      box-sizing: border-box;
      transition: background-color .2s ease, border-color .2s ease, color .2s ease;

      ::v-deep .el-link--inner {
        display: flex;
        align-items: center;
        width: 100%;
        min-width: 0;
        overflow: hidden;
      }

      ::v-deep .svg-icon {
        flex-shrink: 0;
        margin: 0 6px 0 0;
        font-size: 16px;
      }

      ::v-deep .el-link--inner > span {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      &:hover {
        background: #fff5f9;
        border-color: #ff3176;
        color: #ff3176;

        ::v-deep .el-link--inner > span {
          color: #ff3176;
        }
      }

      &.disabled,
      &.is-disabled {
        background: #f5f6f7;
        border-color: transparent;
        color: $--color-text-Placeholder;
        cursor: not-allowed;

        ::v-deep .svg-icon {
          color: $--color-text-Placeholder !important;
        }

        &:hover {
          background: #f5f6f7;
          border-color: transparent;
          color: $--color-text-Placeholder;

          ::v-deep .el-link--inner > span {
            color: $--color-text-Placeholder;
          }
        }
      }
    }
  }
}
</style>

